import React from "react";

function Web3WalletHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Web3 Wallet Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Empowering seamless, secure, and decentralized access to
                    digital assets and dApps, with advanced features for
                    enhanced user control and privacy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Web3WalletHero;
